import { FC, ReactNode, useMemo } from "react";
// 组件
import { ProForm, ProInputNumber } from "../../antd";
// 常量
import { STATUS_CREATED, STATUS_CREATED_CODE } from "../../constants/constant";
import { EditableRowProps, GROUP_NAME } from "../interface";

const EditableRow: FC<EditableRowProps> = props => {
  const { children, 'data-row-key': rowKey, move, ...restProps } = props;
  if (rowKey === undefined) return <tr {...restProps} children={children} />;
  const rowChildren: ReactNode[] | null = useMemo(() => {
    if (!children) return null;
    const newChildren: ReactNode[] = [];
    if (Array.isArray(children) && children.length) {
      newChildren.push(...children);
      newChildren.push(
        <ProForm.Item key='row-status' name={[GROUP_NAME, rowKey, STATUS_CREATED_CODE]} hidden initialValue={STATUS_CREATED.DEFAULT}>
          <ProInputNumber />
        </ProForm.Item>
      );
    }
    return newChildren;
  }, [children]);

  if (!rowChildren) return null;
  return (
    <tr {...restProps} data-row-key={rowKey} children={rowChildren} />
  );
};

export default EditableRow;
